/**
 * TicketDabData.ts
 */
export class TicketDabData {
    constructor() {
        this.reset();
    }
    reset() {
        this.resetCells();
        this.resetDabs();
    }
    resetCells() {
        this.autoHighlightCells = [];
        this.autoDabCells = [];
        this.cellsToDab = [];
        this.standardCells = [];
        this.jokerCells = [];
        this.superJokerCells = [];
        this.autoDabIndex = 0;
    }
    resetDabs() {
        this.numberOfDabs = 0;
        this.slingoDabs = 0;
        this.highlightsActive = false;
    }
    dabSuccess() {
        this.numberOfDabs++;
    }
    autoDabSuccess() {
        this.numberOfDabs++;
        this.autoDabIndex++;
    }
    slingoSuccess(slingos) {
        this.slingoDabs += slingos;
    }
    setStandardCells(value) {
        this.standardCells = value;
        this.cellsToDab = this.cellsToDab.concat(this.standardCells);
    }
    setAutoDabCells(value) {
        this.autoDabCells = value;
    }
    setAutoHighlightCells(value) {
        this.autoHighlightCells = value;
    }
    setJokerCells(value) {
        this.jokerCells = value;
        this.cellsToDab = this.cellsToDab.concat(this.jokerCells);
    }
    setSuperJokerCells(value) {
        this.superJokerCells = value;
        this.cellsToDab = this.cellsToDab.concat(this.superJokerCells);
    }
    setSelectedCell(value) {
        this.selectedCell = value;
    }
    setSuperJokerIndex(value) {
        this.superJokerIndex = value;
    }
    setHighlightsActive(value) {
        this.highlightsActive = value;
    }
    getCellsToDab() {
        return this.cellsToDab;
    }
    getStandardCells() {
        return this.standardCells;
    }
    getJokerCells() {
        return this.jokerCells;
    }
    getSuperJokerCells() {
        return this.superJokerCells;
    }
    getSelectedCell() {
        return this.selectedCell;
    }
    getNumberOfDabs() {
        return this.numberOfDabs;
    }
    getSuperJokerIndex() {
        return this.superJokerIndex;
    }
    getSlingoDabs() {
        return this.slingoDabs;
    }
    getAutoHighlightCells() {
        return this.autoHighlightCells;
    }
    getAutoDabCells() {
        return this.autoDabCells;
    }
    isNumberCell(value) {
        return this.standardCells.indexOf(value) >= 0;
    }
    isSuperJokerCell(value) {
        return this.superJokerCells.indexOf(value) >= 0;
    }
    hasJokerCellToDab() {
        return this.jokerCells.length > 0;
    }
    hasSuperJokerCellToDab() {
        return this.superJokerCells.length > 0;
    }
    hasCellToDab() {
        return this.cellsToDab.length > 0;
    }
    hasAutoDabbed() {
        return this.autoDabCells.length > 0;
    }
    getHighlights() {
        return this.highlightsActive;
    }
    getAutoDabIndex() {
        return this.autoDabIndex;
    }
}
//# sourceMappingURL=TicketDabData.js.map